// desktop header menu open/close

const headerElement = document.getElementById('Header');
const syllablesDesktopShopMenuElement = document.getElementById('HeaderDesktopShopMenu');

let prevScrollValue = 0;
let isRedeclareScrollValue = true;
let isDesktopShopMenuOpen = false;

const controlScrollForHeaderBackgroundColor = () => {
  const headerHeight = document.querySelector('.header__wrapper').offsetHeight;
  const topBarHeight = document.querySelector('.topBar').offsetHeight;
  const currentScrollY = window.scrollY;
  const isPageAtTheTop = currentScrollY <= headerHeight + topBarHeight;
  const scrollUpCondition = currentScrollY < prevScrollValue;
  const scrollDownCondition = currentScrollY > prevScrollValue;

  if (isRedeclareScrollValue) {
    if (scrollUpCondition || isPageAtTheTop) { // show header
      headerElement.classList.add('headerScrollUp');
      headerElement.classList.remove('headerScrollDown');
    } else if (scrollDownCondition && !isPageAtTheTop ) { // hide header
      headerElement.classList.add('headerScrollDown');
      headerElement.classList.remove('headerScrollUp');
    }
  }

  prevScrollValue = currentScrollY;
}

window.addEventListener('scroll', controlScrollForHeaderBackgroundColor);

const disableHeaderDependencyOnScroll = () => isRedeclareScrollValue = false;

const enableHeaderDependencyOnScroll = () => isRedeclareScrollValue = true;

const toggleDesktopShopMenu = () => {
  if (isDesktopShopMenuOpen) {
    enableHeaderDependencyOnScroll();
    syllablesDesktopShopMenuElement.classList.remove(displayBlockImportant);
    isDesktopShopMenuOpen = false;
  } else {
    disableHeaderDependencyOnScroll();
    syllablesDesktopShopMenuElement.classList.add(displayBlockImportant);
    isDesktopShopMenuOpen = true;
  }
}

// burger-menu open/close

const burgerMenuElement = document.getElementById('HeaderBurgerMenu');
const burgerMenuOpenButtonElement = document.getElementById('HeaderBurgerMenuOpenButton');
const burgerMenuCloseButtonElement = document.getElementById('HeaderBurgerMenuCloseButton');

const showBurgerMenu = () => {
  window.removeEventListener('scroll', controlScrollForHeaderBackgroundColor);
  document.body.classList.add(scrollDisableClassName);
  burgerMenuElement.classList.add('header__burgerMenu_active');
  burgerMenuOpenButtonElement.classList.add(hideButtonClassName);
  burgerMenuCloseButtonElement.classList.remove(hideButtonClassName);
}

const hideBurgerMenu = () => {
  window.addEventListener('scroll', controlScrollForHeaderBackgroundColor);
  document.body.classList.remove(scrollDisableClassName);
  burgerMenuElement.classList.remove('header__burgerMenu_active');
  burgerMenuOpenButtonElement.classList.remove(hideButtonClassName);
  burgerMenuCloseButtonElement.classList.add(hideButtonClassName);
}

// cart open/close

const openCartMenu = () => {
  const cartMenuElement = document.getElementById('CartMenuWrapper');
  disableHeaderDependencyOnScroll();
  syllablesDesktopShopMenuElement.classList.remove(displayBlockImportant);
  isDesktopShopMenuOpen = false;
  window.removeEventListener('scroll', controlScrollForHeaderBackgroundColor);
  document.body.classList.add(scrollDisableClassName);
  cartMenuElement.classList.add('displayBlockImportant');
}

const closeCartMenu = () => {
  const cartMenuElement = document.getElementById('CartMenuWrapper');
  enableHeaderDependencyOnScroll();
  window.addEventListener('scroll', controlScrollForHeaderBackgroundColor);
  document.body.classList.remove(scrollDisableClassName);
  burgerMenuElement.classList.remove('header__burgerMenu_active');
  burgerMenuOpenButtonElement.classList.remove(hideButtonClassName);
  burgerMenuCloseButtonElement.classList.add(hideButtonClassName);
  cartMenuElement.classList.remove('displayBlockImportant');
}

// fix 100vh bug on Safari

const updateAppHeight = () => {
  const html = document.querySelector('html');
  html.style.setProperty('--app-height', `${window.innerHeight}px`);
  html.style.setProperty('--app-width', `${window.innerWidth}px`);
}
window.addEventListener('resize', updateAppHeight);
updateAppHeight();
